import { EEntityType } from '@sharedInterfaces/globalEnums';
import type ICertificateDTO from '@sharedInterfaces/ICertificate';
import type {
    ICertificateEmployeeDTO,
    ICertificateOpportunity,
    ICertificateRole,
} from '@sharedInterfaces/ICertificate';
import type { IProductReferenceDTO } from '@sharedInterfaces/IProduct';

import { Entity, entityFieldsGQL } from './Entity';

export const CertificateGQL = `{
    id
    title
    description
    employees {
        id
        title
        startDate
        endDate
    }
    products {
        id
        title
    }
    roles{
        id
        title
    }
    otherNames
    productInfo {
        productName
        manufacturer
        link
    }
    prerequisites
    durationInDays
    cost
    acquisition
    acquisitionLink
    ${entityFieldsGQL}
}`;
export default class Certificate extends Entity implements ICertificateDTO {
    declare id: number;
    type: EEntityType = EEntityType.CERTIFICATE;
    description: string;
    employees: ICertificateEmployeeDTO[];
    otherNames: string[];
    products: IProductReferenceDTO[];
    productInfo?: { productName: string; manufacturer: string; link: string } | undefined;
    prerequisites: string;
    durationInDays?: number | undefined;
    cost?: number | undefined;
    opportunities: ICertificateOpportunity[];
    roles: ICertificateRole[];
    acquisition: string;
    acquisitionLink?: string | undefined;

    constructor(obj: ICertificateDTO) {
        super(obj);
        this.description = obj.description;
        this.employees = obj.employees;
        this.otherNames = obj.otherNames;
        this.products = obj.products;
        this.productInfo = obj.productInfo;
        this.prerequisites = obj.prerequisites;
        this.durationInDays = obj.durationInDays;
        this.cost = obj.cost;
        this.opportunities = obj.opportunities;
        this.roles = obj.roles;
        this.acquisition = obj.acquisition;
        this.acquisitionLink = obj.acquisitionLink;
    }
    async delete() {
        const { default: deleteCertificate } = await import('@src/APIs/graphQl/Certificate/deleteCertificate');
        return deleteCertificate(this.id);
    }
}
